export class BookingSearchParameters {
    pageNumber: number = 1;
    searchText: string = "";
    contractorID: number = 0;
    statusID: number = 0;
    employeeID: number = 0;
    includeCompleted: boolean = false;
    sortField: string = "";
    sortDirection: number = 0;
}